import { cn } from '../../utils/cn';

export function FieldGroup({
  id,
  label,
  error,
  hint,
  success,
  required,
  disabled,
  className,
  children,
}) {
  const dsId = error
    ? 'ds/form/field-group--error'
    : success
      ? 'ds/form/field-group--success'
      : disabled
        ? 'ds/form/field-group--disabled'
        : 'ds/form/field-group--default';

  return (
    <div data-ds-id={dsId} className={cn('space-y-space-2', className)}>
      {label ? (
        <label
          htmlFor={id}
          className="text-type-label font-body font-semibold text-foreground"
        >
          {label}
          {required ? <span className="text-danger-700"> *</span> : null}
        </label>
      ) : null}
      {children}
      {error ? (
        <p className="text-type-body-sm text-danger-700">{error}</p>
      ) : success ? (
        <p className="text-type-body-sm text-success-700">{success}</p>
      ) : hint ? (
        <p className="text-type-body-sm text-muted-foreground">{hint}</p>
      ) : null}
    </div>
  );
}
